import React from "react";

import RelativePostCard from "../../../components/RelativePostCard";

import style from "./style.module.css";

export default function RelatedList({ list = [] }) {
    if (list.length > 0) {
        return (
            <div className={style.postRow}>
                {
                    list.map((item, index) => {
                        return (
                            <RelativePostCard
                                key={`related_article_${index}`}
                                className="popupPost"
                                item={item}
                            />
                        )
                    })
                }
            </div>
        )
    }
    return null
}